import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "biography" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = { class: "row mb-5" }
const _hoisted_4 = { class: "col-md-3 order-md-2 mb-3 mb-md-0 biography-custom" }
const _hoisted_5 = { class: "ps-md-4" }
const _hoisted_6 = {
  key: 0,
  class: "list-unstyled list-py-2 mb-4"
}
const _hoisted_7 = { class: "text-capitalize" }
const _hoisted_8 = ["onClick", "href"]
const _hoisted_9 = {
  key: 1,
  class: "small mb-0"
}
const _hoisted_10 = {
  key: 0,
  class: "social"
}
const _hoisted_11 = { class: "list-inline" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", null, "Social", -1)
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "col-md-9" }
const _hoisted_15 = { class: "mb-5" }
const _hoisted_16 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitCard = _resolveComponent("MrUiKitCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isBlockVisible)
              ? (_openBlock(), _createBlock(_component_MrUiKitCard, {
                  key: 0,
                  class: _normalizeClass(['p-0']),
                  bodyClasses: ['pt-3 pb-0 px-4']
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'bio-item-' + index
                      }, [
                        (_ctx.isVisible(item))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createElementVNode("h5", _hoisted_7, _toDisplayString(item.title), 1),
                              (item.value)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.checkTarget(item)),
                                    href: item.value,
                                    class: "small mb-0 link-navigate"
                                  }, _toDisplayString(item.value), 9, _hoisted_8))
                                : (item.slot)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                      _renderSlot(_ctx.$slots, item.slot)
                                    ]))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (_ctx.socials.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("ul", _hoisted_11, [
                            _hoisted_12,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socials, (socialItem, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: 'bio-social-' + i,
                                class: "list-inline-item"
                              }, [
                                _createElementVNode("a", {
                                  href: socialItem.value,
                                  target: "_blank",
                                  class: "btn btn-soft-secondary btn-xs btn-icon rounded-circle"
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass('bi-' + socialItem.icon)
                                  }, null, 2)
                                ], 8, _hoisted_13)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 3
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: "biography-custom",
              innerHTML: _ctx.content
            }, null, 8, _hoisted_16)
          ])
        ])
      ])
    ])
  ]))
}